angular.module("mercury.modules.stock.stockreceived")
.factory('StockReceived', ["$resource", "settings", function($resource, settings) {
  var StockReceived = $resource(`${settings.stockHost}/internal/stock-received`)
  var StockReceivedLines = $resource(`${settings.stockHost}/internal/stock-received-lines`)

  /**
   * Gets all stock received within the given time period
   * @param {string} from the starting timestamp 
   * @param {string} to the ending timetamp
   * @param {string} property the property to search between (e.g. Received, Created, Invoiced)
   * @param {string} itemId an optional item id to filter by
   * @param {boolean} ifNoneGetLastReceived If there are no stock received within the given time period get the last stock recieved before the time period
   * @returns A list of all stock received that were recieved in the given period 
   */
  function getStockReceivedsByDateRange(from, to, property, itemId, ifNoneGetLastReceived) {
    // The API expects a DateOnly format when we filter by Invoiced property
    // and a DateTimeOffset format when we filter by Received/Created property
    if (property === 'Invoiced') {
      from = moment(from).format('YYYY-MM-DD');
      to = moment(to).format('YYYY-MM-DD');
    }

    return StockReceived.query({
      from,
      to,
      property,
      itemId,
      ifNoneGetLastReceived
    });
  }

  /**
   * Gets all stock received lines within the given time period
   * @param {string} from the starting timestamp 
   * @param {string} to the ending timetamp
   * @param {string} property the property to search between (e.g. Received, Created, Invoiced)
   * @returns A list of all stock received lines that were recieved in the given period 
   */
  function getLinesByDateRange(from, to, property) {
    return StockReceivedLines.query({
      from,
      to,
      property
    });
  }

  return {
    getStockReceivedsByDateRange,
    getLinesByDateRange
  }
}]);